import { connect } from 'react-redux';
import Courses from '../courses/courses';

import { onLoadCourses, onLoadCourse, onExportContent } from '../../reducers/course.reducers';
import { navigate } from '../../reducers/navigator.reducers';

const mapStateToProps = state => ({
  isLoading: state.courses.isLoading,
  groups: state.courses.bulletinBoardContent,
});

const mapDispatchToProps = dispatch => ({
  loadCourse: course => dispatch(onLoadCourse(course)),
  navigate: route => dispatch(navigate({ route })),
  onExportContent: (url) => dispatch(onExportContent(url)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Courses);



// WEBPACK FOOTER //
// ./src/app/main/bulletin-board/courses.container.js